import styles from "./PendingPage.module.css";
import { s } from "./strings";

/** Stand-in for sidebar destinations whose feature module has not been merged yet. */
export function PendingPage({ name }: { name: string }) {
  return (
    <section className={styles.card}>
      <h1 className={styles.title}>{name}</h1>
      <p className={styles.text}>{s.modulePending(name)}</p>
    </section>
  );
}
